import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DconfigCoreSettings } from '../dconfig-core.settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  private websiteManagerUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/WebsiteContentAPI';
  private formsUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/FormsAPI';
  private membershipUrlBase = DconfigCoreSettings.API_ENDPOINT + '/Membership';

  constructor(private http: HttpClient) { }

  getTemplatesTree = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/GetTemplatesTree');
  };
  getTemplates = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/GetTemplates');
  };
  createTemplate = function (template) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/CreateTemplate', template);
  };
  createTemplateClone = function (id, suffix) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createTemplateClone', { Id: id, Suffix: suffix });
  };
  updateTemplate = function (template) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/UpdateTemplate', template);
  };
  updateTemplateLayout = function (relationInfo) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/UpdateTemplateLayout', relationInfo);
  };
  deleteTemplate = function (template) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/DeleteTemplate?Id=' + template.Id + "&Name=" + template.Name + "&Path=" + template.Path);
  };

  getRootTemplates = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getRootTemplates');
  };

  getTemplateView = function (template) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getTemplateView?id=' + template.Id);
  };
  updateTemplateView = function (template, viewObj) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateTemplateView?id=' + template.Id, viewObj);
  };
  getTemplateViewTypeFields = function (template) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getTemplateViewTypeFields?Id=' + template.Id);
  };

  updateScriptsOrdering = function (bundleId, scripts) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateScriptsOrdering', { BundleId: bundleId, Scripts: scripts });
  };
  updateStylesOrdering = function (bundleId, styles) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateStylesOrdering', { BundleId: bundleId, Styles: styles });
  };

  getScriptsTree = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getScriptsTree');
  };
  getScripts = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getScripts');
  };
  createScript = function (Script) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createScript', Script);
  };
  updateScript = function (Script) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateScript', Script);
  };
  deleteScript = function (Script) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteScript?Id=' + Script.Id + "&Name=" + Script.Name + "&Path=" + Script.Path);
  };
  getScriptCode = function (Script) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getScriptCode?id=' + Script.Id);
  };
  updateScriptCode = function (Script, viewObj) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateScriptCode?id=' + Script.Id, viewObj);
  };
  createScriptsBundle = function (ScriptBundle) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createScriptsBundle', ScriptBundle);
  };
  updateScriptsBundle = function (ScriptBundle) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateScriptsBundle', ScriptBundle);
  };
  deleteScriptsBundle = function (ScriptBundle) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteScriptsBundle?Id=' + ScriptBundle.Id + "&Name=" + ScriptBundle.Name);
  };
  getScriptsBundles = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getScriptsBundles');
  };

  getStylesTree = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getStylesTree');
  };
  getStyles = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getStyles');
  };
  createStyle = function (Style) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createStyle', Style);
  };
  updateStyle = function (Style) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateStyle', Style);
  };
  deleteStyle = function (Style) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteStyle?Id=' + Style.Id + "&Name=" + Style.Name + "&Path=" + Style.Path);
  };
  getStyleCode = function (Style) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getStyleCode?id=' + Style.Id);
  };
  updateStyleCode = function (Style, viewObj) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateStyleCode?id=' + Style.Id, viewObj);
  };
  createStylesBundle = function (StyleBundle) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createStylesBundle', StyleBundle);
  };
  updateStylesBundle = function (StyleBundle) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateStylesBundle', StyleBundle);
  };
  deleteStylesBundle = function (StyleBundle) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteStylesBundle?Id=' + StyleBundle.Id + "&Name=" + StyleBundle.Name);
  };
  getStylesBundles = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getStylesBundles');
  };

  getViewTypesTree = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewTypesTree');
  }

  createViewType = function (type) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createViewType', type);
  }

  updateViewType = function (type) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewType', type);
  }

  deleteViewType = function (type) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteViewType?Id=' + type.Id + "&Name=" + type.Name);
  }

  updateViewTypeFields = function (type) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewTypeFields', type);
  }

  deleteViewTypeField = function (fieldId) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/DeleteViewTypeField?id=' + fieldId);
  }

  getViewFieldTypes = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewFieldTypes');
  }

  getViewTypeChildren = function (viewType) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewTypeChildren?Id=' + viewType.Id);
  }

  updateViewTypeChildren = function (viewType, ids) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewTypeChildren?Id=' + viewType.Id, ids);
  }

  getViewTypes = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewTypes');
  }

  getRootViewTypes = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getRootViewTypes');
  }

  getForms = function () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getForms');
  }

}
